<template>
    <nav :class="[...containerClass]">
        <ul class="nav-items">
            <template v-for="tab in tabs">
                <li
                    v-if="! isExcludedTab(tab.name)"
                    :key="tab.name"
                    class="nav-item"
                >
                    <a
                        href="#"
                        :class="['nav-link', { 'active': currentTab === tab.name }]"
                        @click.prevent="$emit('change', {currentTab: tab.name})"
                    >
                        <i
                            v-if="tab.icon"
                            :class="`nav-link-icon far fa-${tab.icon}`"
                        />
                        {{ tab.name }}
                    </a>
                </li>
            </template>
        </ul>
    </nav>
</template>

<script>
export default {
    props: {
        tabs: {
            type: Array,
            required: true,
        },
        currentTab: {
            type: String,
            required: true,
        },
        containerClass: {
            type: Array,
            default: () => ['player-settings-nav'],
        },
        excludedTabs: {
            type: Array,
            default: () => [],
        },
    },

    methods: {
        /**
         * Checks if tab is excluded
         *
         * @param   {string}  tab  Tab name
         *
         * @returns  {boolean}       If is excluded
         */
        isExcludedTab(tab) {
            return this.excludedTabs.includes(tab);
        },
    },
};
</script>
